import { render, staticRenderFns } from "./SchemaChangesBarChart.vue?vue&type=template&id=17187071&"
import script from "./SchemaChangesBarChart.vue?vue&type=script&lang=ts&"
export * from "./SchemaChangesBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports